import { useForm } from 'react-hook-form';
import { useBarcodeQuery } from './useGetBarcodeQuery';
import { useRef } from 'preact/hooks';

export const useGetRegisterList = () => {
  const { control, getValues, setValue, reset } = useForm();
  const isApiCalled = useRef(false);

  const { mutate: onCallBarcode, loading: isLoadingBarcode } = useBarcodeQuery({
    reset,
    getValues,
    setValue,
  });

  const handleOnEnterBarcode = (value) => {
    if (!isApiCalled.current) {
      isApiCalled.current = true;
      onCallBarcode(value);
      setTimeout(() => {
        isApiCalled.current = false;
      }, 2000);
    }
  };

  return {
    control,
    getValues,
    setValue,
    handleOnEnterBarcode,
    isLoadingBarcode,
  };
};
